import React from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUES, changerLangue, i18nActif } from '../i18n';

/* Bascule FR / EN. Invisible tant que la traduction n'est pas activee
   (REACT_APP_I18N_ACTIF) : voir src/i18n/index.js.

   variante 'sombre' : sur le vert de la navbar ; 'clair' : sur fond blanc (pages
   publiques). `flottant` : fixee en haut a droite de la fenetre, pour les pages de
   connexion, d'activation et de mot de passe oublie, sans toucher a leur mise en
   page : un utilisateur anglophone doit pouvoir changer de langue AVANT d'etre
   connecte. */
const COULEURS = {
  sombre: { fond: 'rgba(255,255,255,0.1)', actifFond: '#ffffff', actifTexte: '#155731', texte: 'rgba(255,255,255,0.75)' },
  clair: { fond: '#ffffff', actifFond: '#155731', actifTexte: '#ffffff', texte: '#4b5563' },
};

export default function SelecteurLangue({ variante = 'sombre', flottant = false }) {
  const { t, i18n } = useTranslation('commun');
  if (!i18nActif()) return null;
  const c = COULEURS[variante] || COULEURS.sombre;

  const selecteur = (
    <div
      role="group"
      aria-label={t('langue.choisir')}
      style={{
        display: 'flex', gap: 2, padding: 2, borderRadius: 8, background: c.fond,
        ...(variante === 'clair' ? { border: '1px solid #e5e7eb', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' } : {}),
      }}
    >
      {LANGUES.map((langue) => {
        const active = i18n.language === langue;
        return (
          <button
            key={langue}
            type="button"
            lang={langue}
            title={t(`langue.${langue}`)}
            aria-pressed={active}
            onClick={() => changerLangue(langue)}
            style={{
              height: 28, minWidth: 34, padding: '0 6px', border: 'none', borderRadius: 6,
              cursor: 'pointer', fontSize: 12, fontWeight: 600, letterSpacing: '0.03em',
              background: active ? c.actifFond : 'transparent',
              color: active ? c.actifTexte : c.texte,
              transition: 'background 0.15s',
            }}
          >
            {langue.toUpperCase()}
          </button>
        );
      })}
    </div>
  );

  if (!flottant) return selecteur;
  return (
    <div style={{
      position: 'fixed', zIndex: 1000, right: 16,
      top: 'calc(var(--cb-banniere-h, 0px) + env(safe-area-inset-top, 0px) + 16px)',
    }}
    >
      {selecteur}
    </div>
  );
}
